import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function SnackbarLayout({ className, children }) {
    return <div className={cn('flex items-center gap-3', className)}>{children}</div>;
}

SnackbarLayout.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};
